import { Box, Button, Text } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
// @ts-expect-error canvas-confetti is not typed
import confetti from 'canvas-confetti';

export const Route = createFileRoute('/_authenticated/onboarding/setup-multistreaming/_layout/finish')({
  component: SetupMultistreamingFinishPage,
});

function SetupMultistreamingFinishPage() {
  const confettiCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    confetti({
      particleCount: 120,
      spread: 80,
      origin: { y: 1 },
      gravity: 1.3,
      decay: 0.93,
    });
  }, []);

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        height: '100%',
      }}
    >
      <Box css={{ px: '1rem', flex: 1 }}>
        <img src="/partying-face.png" alt="Setup multistreaming finish" style={{ width: 70, height: 'auto' }} />
        <Text.Subtitle weight="bold" css={{ mb: 0, mt: '1rem' }}>
          Woo-hoo!
        </Text.Subtitle>
        <Text.Body
          variant="caption"
          css={{
            color: '$textPrimary70',
            mb: '1rem',
            maxWidth: 280,
            mx: 'auto',
          }}
        >
          You are all set and ready to go. <br /> Just hit{' '}
          <Text.Body weight="bold" as="span" variant="caption" css={{ color: 'inherit' }}>
            “Start Streaming”
          </Text.Body>{' '}
          whenever you are ready to go live!
        </Text.Body>
      </Box>

      <canvas
        ref={confettiCanvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />

      <Box
        css={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          bgc: '$uiQuaternary',
          padding: '0.5rem',
        }}
      >
        <Button
          density="compact"
          color="neutral"
          css={{ width: '100%' }}
          onClick={() => {
            window.host.getCurrentContainerProperties(({ id, type }) => {
              switch (type) {
                case 'modalDialog':
                  window.host.endModalDialog(true, () => void 0);
                  break;
                case 'dockingWidget':
                  window.host.removeDockingWidgetsByIds([id], () => void 0);
                  break;
              }
            });
          }}
        >
          Finish setup
        </Button>
      </Box>
    </Box>
  );
}
